import React, { Fragment, useState, useEffect } from 'react';
import { Container, Row, Col, Label, Button } from 'reactstrap';
import { useLogin } from '../../../hooks/tomaMuestra/useLogin';
import '../../../assets/css/pantalla1.css'
import { ModalIDcard } from './ModalIDcard';
import { usePantalla1 } from '../../../hooks/tomaMuestra/usePantalla1';
import 'animate.css';
import { useSweetAlert } from "../../../hooks/sweetAlerts/useSweetAlert";
import { QRScanner } from '../../qrScanner/QRScanner';
import { demo, semlab, sharp } from '../../../constant/globalConstantsTypeClients';


const Sample = (props) => {

	let name = localStorage.getItem('flebotomistaUser');
	//////console.log(name);
	let name2 = localStorage.getItem('flebotomisaNombre');
	let name5 = localStorage.getItem('willson');
	const [createSweet, sweetConfirmation, sweetDelete, sweetError, createSweett, sweetConfirmationUpdate, sweetConfirmRepeatExam, sweetConfirmationChangeClient, sweetConfirmationCancel, sweetValidDate, sweetDeleteBacterium1, sweetDoctorDelete, sweetAgreements, sweetAgreementMode, sweetConfirmationCsv, sweetDeleteGlobal, sweetAcceptGlobal] = useSweetAlert()



	const { time, reload, cerrarSesion2 } = useLogin();


	//HIDE USER
	const [show, setShow] = useState(true);
    let url_helen = localStorage.getItem('url_helen');

	// ==========================================
	// INICIO DE NUEVO CÓDIGO: BLOQUEO DE GESTO "ATRÁS"
	// ==========================================
	useEffect(() => {
		// 1. Forzamos una entrada nueva en el historial al montar el componente
		window.history.pushState(null, null, window.location.href);

		const handlePopState = (event) => {
			// 2. El usuario hizo el gesto de regresar (swipe o botón atrás) en la tablet
			// Volvemos a empujar el estado para mantenerlo "atrapado" en esta vista
			window.history.pushState(null, null, window.location.href);

			// 3. Mostramos la alerta de SweetAlert para explicarle por qué no pasó nada
			createSweet(
				"warning",
				"Acción no permitida",
				"Navegación bloqueada",
				"Para evitar perder la información de la toma de muestra, por favor utiliza los botones de la pantalla."
			);
		};

		// Escuchamos el evento de navegación del historial
		window.addEventListener('popstate', handlePopState);

		// Evitar que el usuario recargue la página por accidente (F5 o swipe hacia abajo)
		const handleBeforeUnload = (e) => {
			e.preventDefault();
			e.returnValue = ''; // Necesario para la mayoría de navegadores modernos
		};
		window.addEventListener('beforeunload', handleBeforeUnload);

		// 4. Limpieza: Se ejecuta cuando el componente muere (para no afectar otras pantallas)
		return () => {
			window.removeEventListener('popstate', handlePopState);
			window.removeEventListener('beforeunload', handleBeforeUnload);
		};
	}, []); // El array vacío equivale a ponerlo en el constructor o Page_Load de C#
	// ==========================================
	// FIN DE NUEVO CÓDIGO
	// ==========================================

	const {
		closeModal, handleCardID, method, modalTitle, modal, loading, handleInputChangeNim, nim, getDataNim, data, setFocusNim, nimAutoFocus, onKeyPressNim, handleSelectValuesNim,
		handleScanQR, showQR, setShowQR
	} = usePantalla1();
	return (
		<Fragment  >
			<Container fluid={true} className='bg-barra1   p-0'   >
				<Col xs="12" sm="12" md="12" lg="12" xl="12" className="">
					<Row>
						<Col xs="12" sm="12" md="12" lg="12" xl="12" className=" p-l-0 p-r-0"> <br />
							<div className='box-departamento'>
								<Col sm="12" style={{ textAlign: "-webkit-center" }}>
									<Row>
										<Col xs="12" className="p-0">
											<div className='box-departamento d-flex align-items-center justify-content-between px-2'>

											<div className="time-box">
												<Label className='labelToma1 m-0'>{time}</Label>
											</div>

											<div className="title-box">
												<label className='labelToma1 m-0'>Toma de Muestra</label>
											</div>

											</div>
										</Col>
									</Row>
								</Col>
							</div>
						</Col>
					</Row>
				</Col>
				<Col xs="12" sm="12" md="12" lg="12" xl="12">
					<Row>
						<Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ textAlign: "-webkit-center" }} >
							<div style={{ position: 'absolute', left: "-800", top: "-1000", zIndex: 3 }} className={'ocultar-input'}	>
								<input
									id='inputFocusNim'
									value={nim}
									onChange={(e) => handleSelectValuesNim(e.target.value, "nim")}
									onKeyDown={onKeyPressNim}
									readOnly
									style={{ display: "none" }}
								/>
							</div>
							<div style={{ zIndex: 1 }}>
								<img className="" src={require("../../../assetsToma/imagenes/Barras.gif")} style={{ width: "25%" }} alt="" />
							</div>
						
							<div className='a-line'>
								<label className='labelIniciarMuestra'>Escanea el <b className=''>Código de barras </b> de las muestras  </label> <br />
							</div>
							{(url_helen === sharp || url_helen === semlab || url_helen === demo) && (
								<div>
									<Button
										className="btn-scan"
										onClick={() => setShowQR(true)}
									>
										{/* <i className="pi pi-qrcode mr-2"></i> */}
										Escanear código de barras
									</Button>

									{showQR && (
										<div className="qr-overlay">

										<div className="qr-modal">

											<div className="qr-header">
											<span>Escanear Etiqueta</span>
											<button
												className="qr-close"
												onClick={() => setShowQR(false)}
											>
												✕
											</button>
											</div>

											<div className="qr-body">
												{showQR && <QRScanner onScan={handleScanQR} />}											
											</div>

											<div className="qr-footer">
											<small>Coloca el código dentro del recuadro</small>
											</div>

										</div>

										</div>
									)}
								</div>

							)}
							<label className='labelCode' >o</label> <br />
							<div>

								<Button
										className='bottonIniciarMuestra'
										onClick={handleCardID}
									>
										<i className="fa fa-pencil-square-o mr-2"></i>
										Ingreso Manual
									</Button>
							</div>
							<div className='tap-top' style={{ display: "block" }} onClick={() => { setShow(!show); }}><i className="icon-angle-double-up f-24"></i>
							</div>
						</Col>
						<Col  style={{
								position: 'fixed',
								right: 0,
								zIndex: 5,
								borderTopLeftRadius: '12px'
							}}
							className='divMenu p-l-0'>

							<Col xs="12" sm="12" md="12" lg="12" xl="12">
								{
									show ? (
									<div></div>
									) : (
									<Col xs="12">

										<div className='username-Active-Muestra d-flex align-items-center px-2'>
											<div className="icon-container">
												<i className="fa fa-circle icon-active-small"></i>
											</div>

											<div className="text-container">
												<label className='label-menuToma m-0'>{name2}</label>
											</div>
										</div>

										<br />

										<div className='username-Active-Muestra d-flex align-items-center px-2 pointer'onClick={reload}>
											<div className="icon-container">
												<img
												src={require("../../../assetsToma/imagenes/Recargar.png")}
												alt=""
												/>
											</div>

											<div className="text-container">
												<label className='label-menuToma m-0'>Recargar</label>
											</div>
										</div>

										<br />

										<div className='username-Active-Muestra d-flex align-items-center px-2 pointer' onClick={() => cerrarSesion2(`${process.env.PUBLIC_URL}`)}>
											<div className="icon-container">
												<img
												src={require("../../../assetsToma/imagenes/Salir.png")}
												alt=""
												/>
											</div>

											<div className="text-container">
												<label className='label-menuToma m-0'>Cerrar Sesión</label>
											</div>
										</div>

									</Col>
									)
								}
							</Col>
						</Col>
					</Row>
				</Col>
			</Container>
			<ModalIDcard
				{
				...{
					method, modalTitle, closeModal, modal, loading, getDataNim, data, handleInputChangeNim, nim
				}
				}
			/>
		</Fragment>
	);
}

export default Sample;